import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';

const CountryCode = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {form_component} = props;
	const [countryCodes, setCountryCodes] = useState([]);
	
	const fv = useSelector(state => state.fv);

	const pageData = useSelector(state => state.pageData);
	const {acct_id} = pageData;

	const contactFields = useSelector(state => state.contactFields);
	const {country_code} = contactFields;

	const userData = useSelector(state => state.userData);

	useEffect(() => { // to be updated after render
		loadData();
	}, []);

	useEffect(() => { // to be updated after render
		if (fv && form_component.required) {
			fv.addField('country_code', {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	async function loadData() {
		try {
			let country_codes = [], default_country_code = '';

			if (acct_id === '67eb7294ea77c5da8302bdcb') { // special case for 新竹園軒
				country_codes = ['852'];
				default_country_code = '852';

				setCountryCodes(country_codes);
			} else {
				const response = await axios.get(`/Countries/ajaxGetData/${acct_id}`);

				country_codes = response.data.country_codes;
				default_country_code = response.data.default_country_code;

				setCountryCodes(country_codes);
			}
			
			const payload = {
				field: 'country_code',
				value: default_country_code
			}

			if (!userData) {
				dispatch({type: 'SET_CONTACT_FIELD', payload: payload});
			}
		} catch (e) {
			console.error(e);
		}
	}

	const onChange = (e) => {
		const value = e.target.value;

		const payload = {
			field: 'country_code',
			value: value
		}

		dispatch({type: 'SET_CONTACT_FIELD', payload: payload});
	}

	return (
		<select
			name="country_code"
			className="mw-100px form-select"
			id="country-code"
			value={country_code}
			onChange={onChange}
		>
			{(() => {
				const components = [];
				
				countryCodes.map((countryCode, index) => {
					components.push(
						<option key={`country-code-${index}`} value={countryCode}>{countryCode}</option>
					);
				})

				return components;
			})()}
		</select>
	);

}

export default CountryCode;